import { reducer as redirectReducer } from './slice';

export * from './actions';

export default redirectReducer;
